import React from "react"

import BaseTable from "./BaseTable"

import CompanyInvoicesTable from "./CompanyInvoicesTable";
import Currency from "../../../utils/Currency";
import General from "../../../utils/General";
import moment from "moment/moment";


export default class CompanySubscriptionsTable extends React.Component {

  constructor(props){
    super(props)

    this.state = {

    }

    this.table = React.createRef()
  }

  _getColumns() {
    return [
      {
        Header: 'Date',
        id: 'created_at',
        accessor: companySubscription => moment(companySubscription.created_at).format('DD MMM YYYY')
      },
      {
        Header: 'Company',
        id: 'company.name',
        accessor: 'company.name',
      },
      {
        Header: 'Amount',
        id: 'total',
        Cell: (rowInfo) => {
          let companySubscription = rowInfo.original

          return Currency.format(
            companySubscription.currency.symbol,
            companySubscription.total
          )
        },
      },
      {
        Header: 'Frequency',
        id: 'frequency',
        Cell: rowInfo => {
          let companySubscription = rowInfo.original
          return General.toTitleCase(companySubscription.frequency)
        }
      },
      {
        Header: 'Payment Method',
        id: 'payment_instrument_data',
        Cell: rowInfo => {
          let companySubscription = rowInfo.original
          return companySubscription.payment_instrument_data ? "YES" : "NO"
        }
      },
      {
        Header: 'Total Installments Paid',
        id: 'total_installments_paid',
        accessor: 'total_installments_paid',
        Cell: (rowInfo) => {
          let companySubscription = rowInfo.original
          return companySubscription.total_installments_paid
        }
      },
      {
        Header: 'Total Amount Paid',
        id: 'total_amount_paid',
        Cell: (rowInfo) => {
          let companySubscription = rowInfo.original

          return Currency.format(
            companySubscription.currency.symbol,
            companySubscription.total_amount_paid
          )
        },
      },
    ]
  }

  _renderInvoices(companySubscription){
    return(
      <CompanyInvoicesTable
        companySubscription={companySubscription}
        title="Invoices"
        showExport={false}
      />
    )
  }

  render() {
    let {

    } = this.state
    const columns = this._getColumns()

    return (
      <div>
        <BaseTable
          ref={this.table}
          endpoint={`${window.Api.CompanySubscription}`}
          noDataMessage={"No company subscriptions found"}
          title={this.props.title}
          columns={columns}
          showExport={false}
          defaultSorted={[
            {
              id: "created_at",
              desc: true
            }
          ]}
          SubComponent={row => this._renderInvoices(row.original)}
        />
      </div>
    )
  }
}
